const zh = {
  system: {
    total: "总计",
    rm: "移除",
    desc: "暂无数据",
    cancel: "取消",
    confirm: "确认",
    ondel_address_title: "确定要删除此地址吗？",
    rules_message: "请输入",
    message_success: "成功",
    message_warning: "失败",
    myorder: "我的订单",
    changePassword: "修改密码",
    logout: "登出",
    code: "验证码",
    yes: "是",
    no: "否",
    rm_message: '此操作将删除该记录。是否继续？',
    rm_title: '警告',
    rm_ok: '确认',
    rm_cancel: '取消',
    language: '语言',
    signIn: '登录',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    noOrder: '暂无订单',
    normalMember: '普通用户'
  },
  home: {
    title: "我们的畅销产品",
    memberCoupon: {
      title: "新会员专享",
      desc: "注册后首单享受 10% 折扣",
      action: "立即注册",
      shopAction: "去购物",
    },
    tit0: {
      title: "立即在此免费查询可用性",
    },
    tit1: {
      title: "高达 400 kV 的定制变压器解决方案",
      text: "无论是配电变压器、电力变压器还是特殊解决方案：我们根据您的电网要求，为中压和高压应用提供量身定制的变压器。",
      button: "探索变压器产品",
    },
    tit2: {
      title: "为能源供应商和大型项目提供优化解决方案",
      text: "我们在中国的生产设施实现了高产出——例如，每月可生产多达 1,000 台中压变压器。结合组织良好的物流，我们提供极具竞争力的交货时间。",
      button: "我们的选择",
    },
    wsc_tit1: "为什么选择我们",
    wsc_tit2: "我们的合作伙伴",
    wsc_tit3: "可再生能源的日常生活",
    wsc_tit4: "公司动态分享",
    wsc_tit5: "更多",
    wsc_sub1: "我们的产品符合最高的国际质量和安全标准",
    wsc_sub2: "信任我们与能源行业领先公司的强大伙伴关系",
    wsc_sub3: "随时了解最新进展和项目",
    services_title: "我们的服务",
    services_sub: "为您的能源项目提供量身定制的解决方案",
    readMore: "阅读更多",
    learnMore: "了解更多",
    box1: "开关柜",
    box1_desc: "高效且无 SF₆ 的高压开关柜。",
    box2: "变压器",
    box2_desc: "适用于高压网络的大功率变压器。",
    box3: "中压电缆",
    box3_desc: "可靠的能源分配连接解决方案。",
  },
  banner: {
    title: "支持可再生能源",
  },
  footer: {
    p1: "咨询热线：",
    p2: "联系方式",
    p3: "德国",
    p5: '浏览量',
    avis1: "免费运输",
    avis2: "支付选项",
    search: {
      tit: "立即订阅并联系我们！",
      button: "订阅",
      t1: "我同意",
      t2: " 使用条款 ",
      t3: "和",
      t4: "隐私政策",
    },
    navList: {
      name1: "关于我们",
      children1: {
        name1: "团队支持",
      },
      name2: "支持",
      children2: {
        name2: "我们的生态章程",
      },
    },
  },
  pay: {
    item1: "首页",
    item2: "产品中心",
    item3: "产品信息",
    item4: "支付",
    label1: {
      title: "联系信息",
      text: "已有账号？",
      el: "登录",
      input: "请选择地址",
      tip: "请添加地址",
    },
    label2: {
      title: "送货地址",
      input1: "姓名",
      input2: "其他地址信息",
      input3: "邮政编码",
      input4: "城市",
      input5: "电话",
    },
    info: {
      pro_info: "产品信息",
      type1: "DC Trans Logistik & Trade GmbH",
      type2: "Eisenstrasse 30, 65428 Rüsselsheim",
      type3: "Deutsche Postbank Ndl",
      span1: "免运费",
      span2: "终身服务",
      span3: "无理由退换。制造商质保",
    },
    button: "结算",
    products: {
      message_error: "参数错误！",
    },
    validate: {
      message1: "请选择送货地址",
      message2: "请选择账单地址",
      message3: "请同意条款和条件",
    },
    addOrder: {
      message_success: "下单成功",
      message_warning: "添加订单失败",
    },
    notice:
      "注意：请确保您的姓名贴在门铃上，如果有门禁或需要转交他人，请注明，否则可能无法送达。为了您的包裹安全，请尝试将易碎玻璃物品分开存放。",
    transfer: {
      text1:
        "请将发票金额汇入我们的银行账户。您将通过电子邮件收到订单确认通知，其中包含您的银行详情和订单号",
      text2: "金额",
      text3: "账户持有人姓名",
      text4: "请包含这些详情",
      text5: "银行账号",
      text6: "收款人联系地址",
      text7: "银行名称",
      text8: "同意条款和条件",
      text9: "服务条款",
    },
    result: {
      text1: "订单支付已完成，正在处理中，等待发货。",
      text2: "订单号",
      text3: "付款方式",
      text4: "银行转账",
      text5: "付款金额",
      fail_text: '支付失败，请重试或选择其他支付方式。',
      cancle_text: '支付已取消，订单尚未完成。',
      loading_text: '正在确认支付结果，请稍候...',
    },
    button2: "继续购物",
    button3: "查看订单",
    type: "运输类型",
    pay_info:
      "DHL Global Express Germany 送货上门 / Paket 商店超过 39 欧元免运费",
    pay_info_days: "2-4 个工作日",
    pay_way: "支付方式",
    pay_type: "通过银行电汇支付",
    eur: "(满 3999 €)",
    pay_desc:
      " 通过添加您的银行账户，您授权亚马逊向您的银行发送指令，从您的账户扣款。您也授权您的银行根据这些指令扣除您的账户款项。您可以在扣款日期后 8 周内申请退款。您与银行达成的条款适用。",
    pay_save: "保存以备将来购买",
    pay_info_pay:
      "您的支付信息已加密且安全。<br />保存您的支付方式以备将来购买将帮助您更快结账。",
    pay_more: "了解更多",
    add_bank: "添加银行账户",
  },
  pay2: {
    freeShipping: '包邮',
    text1: '联系详情',
    text2: '配送方式',
    text3: '支付方式',
    text4: '订单完成',
    text14: '请选择您的配送方式。',
    text15: '标准配送',
    text16: '配送至',
    text17: '免费',
    text18: '默认',
    text19: '游客',
    text20: '无地址详情',
    text21: '请选择一个地址',
    text5: "送货地址",
    text6: "账单地址",
    text7: "编辑",
    text8: "其他送货地址",
    text9: "交货时间 2-3 个工作日",
    text10: "配送方式：",
    text11: '您尚未保存送货地址',
    text12: '自提站',
    text13: '前往物流站',
    btn1: "继续",
    btn2: "继续",
    btn3: '添加送货地址',
    btn4: '选择送货地址',
    btn5: '立即购买',
    tit1: '我的地址',
    tit2: '您的账单地址',
    tit3: '选择送货地址？',
    tit4: '送货地址',
    tit5: '选择支付方式？',
    tit6: '购物车',
    option1: 'PayPal',
    option2: '信用卡',
    msg1: '使用 PayPal 支付方便且安全。一旦拥有 PayPal 账号，您只需使用邮箱地址和密码即可支付。这将在完成订单后进行。',
    msg2: '未付发票金额将在您的购买商品发货时从您的信用卡账户扣除。您在完成订单后输入信用卡详情。',
    msg3: '包含增值税。',
    text22: '自提',
    text23: '到店自提，不收邮费',
    submitOrder: '您想完成此订单吗？'
  },
  address: {
    txt: "送货地址",
    p: "注意：送货地址可在完成订单时编辑或添加。",
    button: "添加新地址",
    tag: "标准",
    onEdit: "编辑",
    form: {
      name: "名字",
      phone: "电话号码",
      address: "地址",
      company: '门牌号/公寓/公司名称，C/O',
      street: '街道',
      number: '编号',
      number_tip: '如果没有门牌号，请填入“-”',
      postal_code: "邮政编码",
      city: "城市",
      country: "州/国家",
      checkbox: "设为默认地址",
      checkbox2: "该地址同时也作为账单地址",
      onSubmit: "添加地址",
      default: '默认',
    },
    rules: {
      message: "此字段必填",
    },
    dialog_tiltle: "添加新地址",
    name: "地址",
    shipping: "添加送货地址",
    bill: "账单地址",
  },
  clause: {
    onClose: "全部拒绝",
    acceptAll: "全部接受",
    class1: "我们重视您的隐私",
    class2: "我们使用 Cookie 来提升您的浏览体验、提供个性化内容并分析网站使用情况。点击“全部接受”，即表示您同意我们使用 Cookie。如需了解更多信息，请阅读我们的",
    class3: "",
    class4: "Cookie 政策",
    text4: "",
    class5: "功能性",
    class6: "用于分析、提高网站性能和用户体验的 Cookie。",
    class7: "市场营销",
    class8: "用于在合作伙伴平台上投放个性化广告的 Cookie。",
    onAccept: "全部接受",
    class10: "管理偏好",
    br2: "Cookie 政策",
    class11: "印记",
    msg1: "Cookie 设置",
    msg2: "选择您想要允许的 Cookie。",
    msg3: "市场营销",
    msg4: "在 Google 和社交网络等合作伙伴平台上启用个性化广告。",
    msg5: "功能性",
    msg6: "启用分析以提高网站性能和用户体验。",
    msg7: "您可以随时通过 Cookie 设置撤回您的同意。如果不做选择，将仅使用必要的 Cookie。",
    msg8: "确认选择",
    required: "必要",
    alwaysActive: "始终激活",
  },
  order: {
    item1: "首页",
    item2: "我的订单",
    tip: "请上传汇款凭证",
    upload1: "上传",
    remittance: "汇款凭证：",
    wmsInfo: "运单号：",
    select: "订单状态",
    produces: '产品列表',
    state: {
      label1: "待付款",
      label2: "已付款",
      label3: "已发货",
      label4: "已完成",
    },
    refund: {
      title: "\u7533\u8bf7\u9000\u6b3e",
      orderNo: "\u8ba2\u5355\u53f7",
      amount: "\u9000\u6b3e\u91d1\u989d",
      reason: "\u9000\u6b3e\u539f\u56e0",
      reasonPlaceholder: "\u9009\u62e9\u6216\u8f93\u5165\u9000\u6b3e\u539f\u56e0",
      description: "\u8bf4\u660e",
      descriptionPlaceholder: "\u5411\u5546\u6237\u8865\u5145\u66f4\u591a\u8bf4\u660e",
      evidence: "\u51ed\u8bc1\u56fe\u7247",
      upload: "\u4e0a\u4f20\u56fe\u7247",
      submit: "\u63d0\u4ea4\u7533\u8bf7",
      reasonRequired: "\u8bf7\u9009\u62e9\u6216\u8f93\u5165\u9000\u6b3e\u539f\u56e0\u3002",
      reasonMax: "\u9000\u6b3e\u539f\u56e0\u4e0d\u80fd\u8d85\u8fc7 255 \u4e2a\u5b57\u7b26\u3002",
      reasons: {
        productIssue: "\u5546\u54c1\u95ee\u9898",
        wrongItem: "\u5546\u54c1\u9519\u53d1",
        qualityProblem: "\u8d28\u91cf\u95ee\u9898",
        other: "\u5176\u4ed6",
        addressWrong: "\u6536\u8d27\u5730\u5740\u586b\u9519\u4e86",
        notAsDescribed: "\u4e0e\u63cf\u8ff0\u4e0d\u7b26",
        infoWrong: "\u4fe1\u606f\u586b\u9519\u4e86",
        reorder: "\u91cd\u65b0\u62cd",
        damaged: "\u6536\u5230\u5546\u54c1\u635f\u574f\u4e86",
        delayedOther: "\u672a\u6309\u9884\u5b9a\u65f6\u95f4\u53d1\u8d27 \u5176\u5b83\u539f\u56e0",
      },
    },
  },
  product: {
    item1: "首页",
    item2: "产品中心",
    class: "搜索",
    info: "注册获取更多折扣",
    label: "互联网连接",
    prefixPrice: "",
    suffixPrice: " 起",
    detail: {
      scrollTo1: "支付",
      scrollTo2: "规格",
      item1: "首页",
      item2: "产品中心",
      label: "规格",
      Menge: "数量",
      label1: "运送方式",
      wsc_title1: "描述",
      wsc_title2: "特性",
      wsc_title3: "技术细节",
      class1: "加入购物车",
      class2: "立即购买",
      dowload_tit: "下载",
      dowload1: "安装手册",
      dowload2: "其他文件",
      dowload3: "手册",
      dowload4: "质量保证手册",
      dowload5: "数据表",
      message: "添加成功",
      message2: "该产品已在购物车中，无需再次添加",
      params: "产品参数",
      weight: "重量",
      dimensions: "尺寸",
      inStock: "有现货",
      outOfStock: "暂时无货",
      vat: "(含税)",
      downloadTitle: "资料下载",
      chooseLang: "选择您的语言",
      global: "全球",
      fileName: "文件名",
      fileLanguage: "语言",
      fileFormat: "格式",
      fileSize: "大小",
      fileUpdated: "最后更新",
      fileDownload: "下载",
      noDocs: "未找到相关文档。"
    },
    checkOption: {
      label1: "互联网连接",
    },
  },
  news: {
    item1: "首页",
    item2: "新闻",
    item3: '新闻与趋势',
    item4: '新闻详情',
    item5: '发布时间',
    text1: 'OSS · 新闻与趋势',
    text2: '更多',
    text3: '上一篇',
    text4: '下一篇'
  },
  shop: {
    item1: '首页',
    item2: '我的购物车',
    tit1: "我的购物车",
    tit2: "项目",
    button: "下单",
    tit3: '运费',
    tit4: '发票金额',
    tit5: '待支付金额',
    tit6: '不包含增值税和运费',
    summary: '订单摘要',
    subtotal: '小计',
    free: '免费',
    pendingShipping: '待计算',
    continue: '继续购物',
  },
  solution: {
    tit: "关于我们",
    tit1: "我们热切希望 Oss Energy 计划能够提供可持续的能源解决方案，既保护环境又满足客户的需求。凭借丰富的经验和敬业的专家团队，我们的目标是让世界变得更绿、更清洁。",
    tit2: "我们的服务包括为住宅和商业客户安装及提供高质量的太阳能发电站。我们根据个人需求和要求进行量身定制。从早期的咨询、设计、安装到定期的维护和监控，我们将确保太阳能的使用顺畅高效。",
    tit3: "我们对质量和可持续性的承诺是我们商业计划的核心。我们与客户紧密合作，确保太阳能发电站的最佳运行和最大效率。我们都以能为客户带来低成本能源和长期节省而感到自豪。",
    wsc_title1: "产品系列",
    tit4: "我们热切希望 Oss Energy 计划能够提供可持续的能源解决方案，既保护环境又满足客户的需求。凭借丰富的经验和敬业的专家团队，我们的目标是让世界变得更绿、更清洁。请立即致电 +49 69 71585988 或点击了解更多。",
    btn: "了解更多",
    wsc_title2: " 我们的优势",
    tit5: "通威太阳能叠瓦组件采用创新的叠瓦技术，比传统的太阳能组件更坚固、更美观，也能更有效地利用太阳能，从而提高发电效率",
    wsc_title3: "解决方案",
    tit6: "在 Oss Energy，我们的重点不仅在于产品的质量和性能，还在于出色的客户服务。我们经验丰富的团队按照行业标准安装您的电站，并提供全面的售后服务，以确保长期运行和维护。我们专注于您的需求，提供可靠的解决方案和技术支持。",
    tit7: "解决方案 1：您还没有光伏系统",
    tit8: "我们提供具有高盈利能力和长期质保的定制化绿色能源解决方案。根据您的个人功耗，我们设计经济的能源计划，为您带来最快的收益。我们的高品质产品使您的收益时间最大化。",
    tit9: "解决方案 2：您已有光伏系统但需要储能",
    tit10:
      "我们的快速光伏储能解决方案允许您连接电池储能系统，而无需重新获得电网连接批准或拆除现有系统。通过使用 FIT 系列逆变器，我们实现了电池与您现有光伏系统之间的高效连接。您通过快速实施高效的储能系统来节省时间并提高自用率。",
    wsc_title4: "荣誉",
    tit11:
      "通威光伏组件已被彭博新能源财经 (Bloomberg New Energy Finance) 列入全球前 10 名 Tier-1 组件名单。（2022 年第 4 季度和 2023 年第 1 季度）",
    tit12:
      "SolaX 在英国 Solar Power Portal 颁奖典礼上荣获“最佳商业逆变器”奖，在澳大利亚 Intersolar 颁奖典礼上荣获“最佳电池储能系统”奖，并获得德国 EUPD Research 颁发的英国顶级逆变器和顶级电池奖",
    item1: "Tier-1 名单",
    item2: "英国顶级逆变器",
    item3: "澳大利亚顶级 BESS",
    item4: "英国和德国顶级逆变器与电池",
    item5: "ECS",
    wsc_title5: "产品优势",
    wsc_title6: "针对私人家庭",
    li1: "容量范围：我们专注于提供容量在 6 到 30 千瓦峰值 (kWp) 之间的光伏系统，非常适合私人家庭的能源需求。",
    li2: "定制化解决方案：我们量身定制的光伏解决方案完美融入个人能源需求和空间条件。",
    li3: "高效安装：我们的专家确保快速简单的安装，与家庭环境无缝融合。",
    li4: "成本效益和补贴：我们支持客户获得最大的财务收益，包括节省能源成本和政府补贴。",
    li5: "简单维护：我们的低维护光伏系统提供可靠且高效的能源供应。",
    li6: "监管合规：我们保证符合所有当地建筑规范和法律要求。",
    wsc_title7: "针对商业",
    li7: "容量范围：对于企业，我们提供高达 2000 千瓦峰值 (kWp) 的全面光伏解决方案，专为商业和工业运营的高能源需求而设计。",
    li8: "大型光伏项目：我们的系统具有可扩展性，可以灵活适应复杂的运营结构。",
    li9: "先进的能源管理系统：我们将光伏系统集成到现有的能源管理结构中，为能源生产、存储和管理提供创新解决方案。",
    li10: "全面的咨询和合规：我们经验丰富的团队引导您通过复杂的监管环境，确保合规性和运营效率。",
    li11: "长期投资回报：我们帮助企业实现长期财务和生态效益。",
    li12: "专业维护和监控：我们提供先进的服务以最大限度地发挥光伏系统的性能。",
    bTitle1: '我们的住宅项目',
    bTitle2: '我们的商业项目',
    bTip: '我们让您的家更绿！',
    bTip2: '我们让您的企业更绿！'
  },

  login: {
    login_name: "登录",
    register_name: "注册",
    code: "验证码",
    login_tit: "享受最佳体验",
    tit: "只需登录即可跟踪订单、调整设置并享受独家优惠。",
    tit1: "请输入注册信息并登录以查看注册后的折扣信息",
    tit2: "已有账号，忘记密码？",
    form: {
      name: "姓名",
      namePlaceholder: "请输入您的姓名",
      email: "邮箱",
      emailPlaceholder: "your-email@example.com",
      password: "密码",
      passwordPlaceholder: "请输入密码",
      createPasswordPlaceholder: "请设置强密码",
      confirmPassword: "确认密码",
      confirmPasswordPlaceholder: "请再次输入密码",
      code: "验证码",
      codePlaceholder: "请输入验证码",
    },
    checkEmail: {
      tit1: "邮箱不能为空",
      tit2: "请输入您的邮箱地址。",
    },
    validatePass2: {
      tit1: "请再次输入密码",
      tit2: "两次输入的密码不一致！",
    },
    password: {
      message: "密码包含 8 到 16 个字符",
      tit: "不得与用户名相同",
    },

    checkCode: {
      tit: "验证码为空",
    },
    content: "请输入字母和数字的组合",
  },
  resetPwd: {
    name: "重置密码",
    reset: "重置",
    login: "登录",
    tit1: "确认邮箱",
    tit2: "设置密码",
    tit3: "完成",
    next: "下一步",
    prev: "上一步",
  },
  error: {
    page: "页面未找到",
    return: "返回上一页",
  },
  header: {
    menuList: {
      name1: "畅销产品",
      name2: "关于我们",
      name3: "能源设备",
      name4: "网上商店",
      name5: "联系我们",
      children1: {
        name1: "住宅",
      },
      children3: {
        name1: "变压器",
        name2: "开关柜",
        name3: "中压电缆",
      },
    },
  },
  contact: {
    title: "与我们联系",
    messgage1:
      "我们很高兴为您提供帮助，请致电我们或向我们发送消息。我们期待收到您的来信！",
    messgage2:
      "我同意本网站存储我提交的信息，以便回答我的请求。",
    form: {
      title: "发送消息",
      subtitle: "填写表格，我们会尽快回复您",
      label0: "职位",
      label1: "公司",
      label2: "全名",
      label3: "邮箱",
      label4: "电话",
      label5: "消息",
      label6: "GDPR 同意",
      placeholder0: "例如：项目经理",
      placeholder1: "您的公司名称",
      placeholder2: "您的全名",
      placeholder3: "your.email@example.com",
      placeholder4: "+49 123 456 7890",
      placeholder5: "告诉我们我们可以如何帮助您...",
    },
    info: {
      address: "地址",
      phone: "电话",
      email: "邮箱",
      hours: "营业时间",
      workdays: "周一 - 周五",
      time: "上午 9:00 - 下午 6:00",
    },
    button: "发送消息",
  },
  top3: {
    tit1: {
      title: 'X3 混合动力逆变器',
      text: 'SolaX X3 混合动力逆变器提供 5 kW 至 15 kW 的型号，充放电效率高达 97.5%。它为光伏系统提供 200% 的超额配置，AC 过载输出高达 110%。具备阴影跟踪功能、经济运行模式并支持大功率太阳能组件（高达 150% 的光伏输入），能高效地将电能从光伏系统存储到电池中。具备 IP65 防护和浪涌保护，安全可靠，并提供智能技术，可在 10 毫秒内快速切换，兼容锂离子电池和铅酸电池，且负载响应迅速（0.3 秒）。'
    },
    tit2: {
      title: '智能电动汽车充电器',
      text: 'SolaX 智能电动汽车充电器为电动汽车提供先进的充电选项。提供三种型号：X1-EVC-7.2K、X3-EVC-11K 和 X3-EVC-22K，实现了灵活的充电选择。该充电器用户友好，可选插头或插座以便于安装，适用于室内和室外使用。它提供智能负载平衡控制，并允许设置定时器以利用波峰和波谷电价。提供三种充电模式：绿色模式（利用光伏能源）、快速模式（最大充电速度）和 ECO 模式（固定功率）。远程监控和控制通过用户友好的应用程序完成。'
    },
    tit3: {
      title: 'T30 电池',
      text: '来自 SolaX Triple Power 系列的 T30 电池为太阳能存储提供了最先进的解决方案。它提供从 3.3 kWh 到 17.6 kWh 的各种容量，适用于低压和高压安装。其高存储容量可实现太阳能的长期存储，减少对电网的依赖。该电池采用先进的磷酸铁锂技术，具有高能量密度和长寿命。此外，系统是模块化且可扩展的，因此客户可以随着存储需求的增加添加额外的电池。用户友好的软件可实现对能源消耗的轻松监控和控制。'
    }
  },
  airset: {
    breadcrumb: {
      home: '首页',
      products: '产品中心',
      current: 'RM AirSeT™'
    },
    hero: {
      title: 'RM AirSeT™',
      subtitle: '用于二次配电的无 SF6 紧凑型或可扩展型气体绝缘环网柜，高达 24 kV / 630 A / 20 kA'
    },
    products: {
      title: '产品系列',
      subtitle: '三种变体满足不同的应用需求',
      view3d: '查看 3D 模型',
      p1: {
        name: 'RM AirSeT™ Compact',
        subtitle: '紧凑型解决方案',
        desc: '用于标准环网柜网络的紧凑型预配置开关柜。非常适合城市地区空间受限的场合。',
        specs: '高达 24 kV | 630 A | 20 kA',
        badge: '节省空间'
      },
      p2: {
        name: 'RM AirSeT™ Active Plus',
        subtitle: '可扩展变体',
        desc: '具有灵活扩展选项的模块化系统。非常适合不断增长的能源需求和未来的扩张阶段。',
        specs: '高达 24 kV | 630 A | 20 kA',
        badge: '推荐'
      },
      p3: {
        name: 'RM AirSeT™ Digital',
        subtitle: '智能版本',
        desc: '全数字化开关柜，配备物联网传感器并集成 EcoStruxure™，适用于智能电网应用。',
        specs: '高达 24 kV | 630 A | 20 kA',
        badge: '智能电网'
      }
    },
    overview: {
      badge: '无 SF6',
      title: '用于可持续配电的气体绝缘开关柜',
      desc: 'RM AirSeT™ 是施耐德电气的一款环保、无 SF6 的气体绝缘开关柜 (GIS)。它使用纯空气作为绝缘介质，为中压环网柜网络提供可持续的解决方案。设计为紧凑型或可扩展型，非常适合城市和工业环境中的二次配电。',
      features: {
        f1: {
          title: '100% 无 SF6',
          desc: '纯空气绝缘，无有害温室气体'
        },
        f2: {
          title: '紧凑灵活',
          desc: '节省空间的设计，可根据需要扩展'
        },
        f3: {
          title: '环网柜技术',
          desc: '二次配电网络的可靠解决方案'
        }
      }
    },
    model3d: {
      title: '查看 3D 模型',
      description: '在交互式 360° 视图中探索 RM AirSeT™',
      button: '打开 3D 模型'
    },
    merkmale: {
      title: '优势',
      subtitle: '用于可持续配电的创新技术',
      m1: {
        title: '可持续性',
        desc: '纯空气绝缘介质 - 零温室气体排放，GWP = 1',
        advantages: [
          '空气绝缘 + 真空断路（无氟气体）',
          '全球变暖潜能值为零（无寿命结束处理成本）'
        ]
      },
      m2: {
        title: '安全',
        desc: '专为城市环境和有限空间设计的节省空间结构',
        advantages: [
          'IP67 外壳（环境防护绝缘）',
          '3 位置开关 + SVI™（无毒切换）',
        ]
      },
      m3: {
        title: '可靠性',
        desc: '根据未来的能源需求灵活扩展',
        advantages: [
          '40 年品质（已安装超过 500 万台）',
          '密封的 IP67 气缸（终身免维护）'
        ]
      },
      m4: {
        title: '灵活性',
        desc: '与 SF6 开关柜相同的安全标准，经过全面测试',
        advantages: [
          '1 个外壳内有 1-4 个单元（占地面积小）',
          '可定制的预接线套件（2 种开关柜/底座高度）'
        ]
      },
      m5: {
        title: '连接性',
        desc: '耐用的组件，降低整个生命周期的运营成本',
        advantages: [
          'IT/OT 集成（实时监控）',
          '3D 模型 + DMS 链接（支持预测性维护）',
        ]
      },
      m6: {
        title: '数字化就绪',
        desc: '兼容 EcoStruxure™，实现智能能源管理和远程监控',
        advantages: [
          'EcoStruxure™ 集成',
          '提供物联网传感器',
        ]
      }
    },
    benefits: {
      title: '您的收益',
      subtitle: '可持续、安全且面向未来',
      b1: {
        title: '气候中立',
        desc: '零 SF6 排放，GWP = 1，符合 F-Gas 法规和绿色新政目标'
      },
      b2: {
        title: '成熟技术',
        desc: '经过测试的空气绝缘技术，与 SF6 开关柜具有相同的安全水平'
      },
      b3: {
        title: '低维护',
        desc: '耐用设计，降低整个生命周期的运营成本'
      },
      b4: {
        title: '面向未来',
        desc: '符合即将出台的环保法规，使用不受限制'
      }
    },
    applications: {
      title: '应用领域',
      subtitle: '中压配电中的多功能应用',
      a1: {
        title: '住宅与商业建筑',
        desc: '为住宅综合体、办公楼和购物中心供电'
      },
      a2: {
        title: '工业',
        desc: '生产设施和制造工厂的配电'
      },
      a3: {
        title: '关键基础设施',
        desc: '为医院、数据中心和公共设施提供可靠供应'
      },
      a4: {
        title: '公用事业',
        desc: '公用事业和网络运营商环网柜网络中的二次配电'
      },
      a5: {
        title: '可再生能源',
        desc: '太阳能和风能项目的并网与分配'
      },
      a6: {
        title: '运输与交通',
        desc: '为火车站、地铁系统和机场供电'
      }
    },
    specs: {
      title: '技术规格',
      subtitle: '满足最高要求的高性能参数',
      electrical: {
        title: '电气数据',
        voltage: '额定电压',
        voltage_val: '高达 24 kV',
        current: '额定电流',
        current_val: '高达 630 A',
        shortCircuit: '短路额定值',
        shortCircuit_val: '高达 20 kA',
        insulation: '绝缘介质',
        insulation_val: '纯空气（无 SF6）'
      },
      environmental: {
        title: '环境数据',
        gwp: '全球变暖潜能值 (GWP)',
        gwp_val: '1 (空气)',
        temp: '工作温度',
        temp_val: '-5°C 至 +40°C',
        protection: '防护等级',
        protection_val: 'IP2X / IP3X',
        altitude: '最大工作海拔',
        altitude_val: '高达 1000 m ASL'
      },
      mechanical: {
        title: '机械数据',
        dimensions: '设计',
        dimensions_val: '紧凑型 / 可扩展型',
        installation: '安装',
        installation_val: '室内',
        lifespan: '寿命',
        lifespan_val: '> 30 年',
        maintenance: '维护',
        maintenance_val: '低维护'
      }
    },
    features: {
      title: '数字化特性',
      f1: {
        title: 'EcoStruxure™ 就绪',
        desc: '与用于基于物联网的能源管理的 EcoStruxure™ 平台完全兼容'
      },
      f2: {
        title: '智能监控',
        desc: '可选传感器和测量设备用于状态监测和负荷管理'
      },
      f3: {
        title: '数字化服务',
        desc: '基于云的分析服务，用于预测性维护和运行优化'
      },
      f4: {
        title: '远程访问',
        desc: '安全的远程诊断和配置，确保最高可用性'
      }
    },
    cta: {
      title: '配电的未来是无 SF6 的',
      desc: 'RM AirSeT™ 将成熟的开关柜技术与环保创新相结合。联系我们，就您的可持续中压解决方案进行个别咨询。',
      btn1: '请求咨询',
      btn2: '下载产品数据表'
    }
  }
};
export default zh;
